import React from 'react';
import {Button, Flex, Title} from '@priority-software/priority-style-react';
import styles from '../styles/settingsPanel.module.scss';
import texts from '../../texts';
import {createDataTestId} from '../../../../../../utils/dataTestId';

export const Header = ({onReset}) => {
    return (
        <Flex
            justifyContent="space-between"
            alignItems="center"
            componentClasses={styles.settingsHeader}
            {...createDataTestId(`panel-settings-header`, true)}
        >
            <Title skin="h5" textColor="primary-700" text={texts.settings_title} />
            <Button skin="text" size="small" onClick={onReset}>
                {texts.clear_settings}
            </Button>
        </Flex>
    );
};
